import React from 'react';
import { renderToString } from 'react-dom/server';
import { Skeleton } from 'antd';

const ANTD_NOTIFICATIONS_CSS_ID = '_shipium-disable-ant-notifications';
const MAIN_HTML_TAG_CSS_ID = '_shipium-display-main-html-tag';
const SKELETON_CONTAINER_ID = '_shipium-skeleton-overlay';

export function disableAntNotificationsCss(): void {
  if (document.getElementById(ANTD_NOTIFICATIONS_CSS_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = ANTD_NOTIFICATIONS_CSS_ID;
  style.textContent = `
    .ant-notification {
      display: none !important;
    }
  `;

  document.head.appendChild(style);
}

export function enableAntNotificationsCss(): void {
  const style = document.getElementById(ANTD_NOTIFICATIONS_CSS_ID);
  if (style) {
    style.remove();
  }
}

export function disableMainHtmlTag(): void {
  if (document.getElementById(MAIN_HTML_TAG_CSS_ID)) {
    return;
  }

  const style = document.createElement('style');
  style.id = MAIN_HTML_TAG_CSS_ID;
  style.textContent = `
    main.ant-layout-content {
      display: none !important;
    }
  `;

  document.head.appendChild(style);
}

export function enableMainHtmlTag(): void {
  const style = document.getElementById(MAIN_HTML_TAG_CSS_ID);
  if (style) {
    style.remove();
  }
}

function buildSkeletonHtmlString(width: number): HTMLDivElement {
  // Create container with absolute positioning
  const skeletonContainer = document.createElement('div');
  skeletonContainer.id = SKELETON_CONTAINER_ID;
  skeletonContainer.style.position = 'absolute';
  skeletonContainer.style.top = '63px';
  skeletonContainer.style.left = `${width}px`;
  skeletonContainer.style.padding = '24px';
  skeletonContainer.style.zIndex = '1000';
  skeletonContainer.style.width = `calc(100vw - ${width}px)`;
  skeletonContainer.style.minWidth = '300px';

  // Generate HTML string from Skeleton component
  const skeletonHtml = renderToString(
    React.createElement(Skeleton, {
      active: true,
      paragraph: { rows: 8 },
      title: true,
    }),
  );

  // Set the HTML string directly
  skeletonContainer.innerHTML = skeletonHtml;

  return skeletonContainer;
}

export const renderSkeletonHtmlString = () => {
  // Remove existing skeleton container if it exists
  const existingContainer = document.getElementById(SKELETON_CONTAINER_ID);
  if (existingContainer) {
    existingContainer.remove();
  }

  const getAsideWidth = () => {
    const currentAside = document.querySelector('aside');
    if (!currentAside) return 225;
    const width = currentAside.offsetWidth;
    return width > 0 ? width : 225;
  };

  const asideWidth = getAsideWidth();

  const skeletonContainer = buildSkeletonHtmlString(asideWidth);

  // Append to document body (outside React root)
  document.body.appendChild(skeletonContainer);

  // Simple polling approach - check aside width every 100ms
  let lastWidth = asideWidth;
  const pollInterval = setInterval(() => {
    const container = document.getElementById(SKELETON_CONTAINER_ID);
    if (!container) {
      clearInterval(pollInterval);
      return;
    }

    const currentWidth = getAsideWidth();
    if (currentWidth !== lastWidth) {
      container.style.left = `${currentWidth}px`;
      container.style.width = `calc(100vw - ${currentWidth}px)`;
      lastWidth = currentWidth;
    }
  }, 50);

  // Store interval for cleanup
  (skeletonContainer as any)._pollInterval = pollInterval;
};

// Add cleanup function for the skeleton
export const removeSkeletonHtmlString = () => {
  const container = document.getElementById(SKELETON_CONTAINER_ID);
  if (container) {
    // Clean up interval
    const pollInterval = (container as any)._pollInterval;
    if (pollInterval) {
      clearInterval(pollInterval);
    }

    container.remove();
  }
};
